import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { selectAccounts, setCurrentAccount } from 'state/instantCredit';
import { selectTenant } from 'state/tenant';
import { InstantCredit } from 'state/instantCredit';
import useNavigationHelpers from 'hooks/useNavigationHelpers';
import AccountSelectionView from './AccountSelectionView';
import useAnalyticsVariables from 'hooks/useAnalyticVariables';
import useAnalytics, { Event } from 'hooks/useAnalytics';
import useFmcHost from 'hooks/useFmcHost';
import { receiveAccountExists } from 'fmc-sdk';

const AccountSelection: React.FC = () => {
  const dispatch = useDispatch();
  const { push } = useNavigationHelpers();
  const tenant = useSelector(selectTenant);
  const fmcDispatch = useFmcHost();
  const accounts = useSelector(selectAccounts);
  const { setAnalyticsVariables } = useAnalyticsVariables();
  const { sendEvents } = useAnalytics();

  const onWidgetClick = useCallback(
    (account: InstantCredit) => {
      setAnalyticsVariables({
        callId: account.callId,
        applicationId: account.applicationId,
        accountId: account.accountId,
      });
      sendEvents([Event.AccountSelected]);
      fmcDispatch(
        receiveAccountExists({
          message: 'An existing account exists',
          callId: account.callId || null,
          rewards: account.rewards,
          cardType: account.cardType,
          ...account,
        }),
      );
      dispatch(setCurrentAccount(account));
      push('/approval');
    },
    [dispatch, fmcDispatch, push, sendEvents, setAnalyticsVariables],
  );

  return (
    <AccountSelectionView
      tenant={tenant}
      accounts={accounts}
      onWidgetClick={onWidgetClick}
    />
  );
};

export default AccountSelection;
